export const TINYMCE_DEFAULT_CONFIG = {
    menubar : false,

};
